import { camelCase, startCase } from 'lodash';

import {
  DefermentWorkoutPlan,
  FlexModificationWorkoutPlan,
  ForbearanceWorkoutPlan,
  RepaymentWorkoutPlan,
  WorkoutPlanType,
} from '@willow/graphql-iso/src/app';
import { LoanReportingWorkoutPlanType } from '@willow/types-iso';

import { assertNever } from './assertNever';

export const formatWorkoutPlanType = (type: WorkoutPlanType) => {
  switch (type) {
    case WorkoutPlanType.PaymentDeferment:
      return 'Payment Deferment';
    case WorkoutPlanType.RepaymentPlan:
      return 'Repayment Plan';
    case WorkoutPlanType.Forbearance:
      return 'Forbearance';
    case WorkoutPlanType.FlexModification:
      return 'Flex Modification Trial';
    default:
      assertNever(type);
  }
};

export const formatWorkoutPlanTypeShort = (type: WorkoutPlanType) => {
  switch (type) {
    case WorkoutPlanType.PaymentDeferment:
      return 'Deferment';
    case WorkoutPlanType.RepaymentPlan:
      return 'Repayment';
    case WorkoutPlanType.Forbearance:
      return 'Forbearance';
    case WorkoutPlanType.FlexModification:
      return 'Flex Modification';
    default:
      assertNever(type);
  }
};

export const getWorkoutPlanTypeLabel = (
  plan: DefermentWorkoutPlan | FlexModificationWorkoutPlan | ForbearanceWorkoutPlan | RepaymentWorkoutPlan,
  isShort: boolean,
) => {
  switch (plan.type) {
    case WorkoutPlanType.Forbearance:
      return `${startCase(camelCase((plan as ForbearanceWorkoutPlan).forbearanceType))} Forbearance`;
    case WorkoutPlanType.PaymentDeferment:
    case WorkoutPlanType.RepaymentPlan:
    case WorkoutPlanType.FlexModification:
      return isShort ? formatWorkoutPlanTypeShort(plan.type) : formatWorkoutPlanType(plan.type);
    default:
      assertNever(plan.type);
  }
};

export const formatLoanReportingWorkoutPlanType = (type: LoanReportingWorkoutPlanType) => {
  switch (type) {
    case LoanReportingWorkoutPlanType.enum.PAYMENT_DEFERMENT:
      return 'Payment Deferment';
    case LoanReportingWorkoutPlanType.enum.REPAYMENT_PLAN:
      return 'Repayment Plan';
    case LoanReportingWorkoutPlanType.enum.FLEX_MODIFICATION:
      return 'Flex Modification Trial';
    case LoanReportingWorkoutPlanType.enum.FORBEARANCE:
      return 'Forbearance';
    case LoanReportingWorkoutPlanType.enum.NONE:
      return 'None';
    default:
      assertNever(type);
  }
};
